// extracted by mini-css-extract-plugin
export default {"sliderImg":"SliderImg_sliderImg__yt8QY","faq":"SliderImg_faq__zBklH","faq__img":"SliderImg_faq__img__JfEmz","faq__text":"SliderImg_faq__text__Xiu54"};